import { NavLink, Navigate, Outlet } from "react-router";
import { ActivityPanel } from "@/features/activity/activity-page";
import { cn } from "@/lib/cn";

const tabs = [{ to: "activity", label: "Activity" }] as const;

export function ReportsPage() {
  const base = "/reports";

  return (
    <div className="space-y-5">
      <div>
        <h2 className="text-xl font-semibold text-rs-ink">Reports</h2>
        <p className="text-sm text-rs-ink-muted">
          v1 includes Activity only — a timeline of sync runs, deliveries, and
          related workspace events. Additional report types are deferred.
        </p>
      </div>

      <div
        className="flex flex-wrap gap-1 border-b border-rs-border pb-2"
        role="tablist"
        aria-label="Report sections"
      >
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={`${base}/${tab.to}`}
            role="tab"
            className={({ isActive }) =>
              cn(
                "inline-flex h-8 items-center rounded-rs-sm px-3 text-sm font-medium text-rs-ink-muted hover:bg-rs-muted hover:text-rs-ink",
                isActive && "bg-rs-accent-soft text-rs-accent-ink",
              )
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
}

export function ReportsIndexRedirect() {
  return <Navigate to="activity" replace />;
}

export function ReportsActivityTab() {
  return <ActivityPanel />;
}
